const API_BASE_URL = 'https://api.quali-d.com'

export class AuthService {
  static async login (credentials) {
    try {
      const body = {
        country_code: credentials.country_code,
        phone: credentials.phone,
        password: credentials.password
      }

      if (credentials.cf_turnstile_response) {
        body.cf_turnstile_response = credentials.cf_turnstile_response
      }

      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify(body)
      })

      const contentType = response.headers.get('content-type')
      if (!contentType || !contentType.includes('application/json')) {
        throw new Error('Server returned an unexpected response. Please try again.')
      }

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.message || 'Login failed')
      }

      const isSuccess = data.status === 'success' || data.success === true
      if (!isSuccess) {
        throw new Error(data.message || 'Invalid credentials')
      }

      // TOTP required — return early, real token will come after code verification
      if (data.totp_required === true) {
        return data
      }

      if (data.success && data.token) {
        data.user = {
          id: data.user_id,
          name: data.name,
          phone: data.phone,
          email: data.email,
          role: data.role_name,
          role_id: data.role_id,
          roleId: data.role_id,
          company: data.company_name,
          plan: data.plan_name,
          planId: data.plan_id,
          country_code: data.country_code
        }
      }

      return data
    } catch (error) {
      if (error instanceof TypeError && error.message.includes('fetch')) {
        throw new Error('Network error. Unable to connect to the server.')
      }
      throw error
    }
  }

  static setAuthData (authData) {
    if (authData.token) {
      localStorage.setItem('auth_token', authData.token)
      localStorage.setItem('token', authData.token)
    }
    if (authData.user) {
      localStorage.setItem('user_data', JSON.stringify(authData.user))
      localStorage.setItem('user', JSON.stringify(authData.user))
    }
  }

  static getAuthToken () {
    return localStorage.getItem('auth_token')
  }

  static getUserData () {
    const userData = localStorage.getItem('user_data')
    return userData ? JSON.parse(userData) : null
  }

  static isAuthenticated () {
    return !!this.getAuthToken()
  }

  static logout () {
    localStorage.removeItem('auth_token')
    localStorage.removeItem('user_data')
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  }

  static async makeAuthenticatedRequest (url, options = {}) {
    const token = this.getAuthToken()

    const headers = {
      'Content-Type': 'application/json',
      ...options.headers
    }

    if (token) {
      headers.Authorization = `Bearer ${token}`
    }

    return fetch(url, { ...options, headers })
  }

  static async getUserCredits () {
    try {
      const token = this.getAuthToken()
      if (!token) throw new Error('No authentication token found')

      const response = await fetch('https://dashboard.quali-d.com/api/get_my_credit.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify({ token })
      })

      if (!response.ok) throw new Error('Failed to fetch user credits')

      const data = await response.json()

      if (Array.isArray(data) && data.length > 0) {
        return { credits: data[0].minutes || 0, id: data[0].id }
      }

      return { credits: 0, id: null }
    } catch (error) {
      return { credits: 0, id: null, error: error.message }
    }
  }
}
